var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.generalInvoiceStatistics)?_c('div',[_c('div',{staticClass:"chart"},[_c('Apexchart',{attrs:{"type":"line","width":"100%","height":"100%","options":{
        xaxis: {
          categories: _vm.generalInvoiceStatistics.map(function (e) { return e.period; }),
          labels: {
            rotate: -20,
            rotateAlways: true,
          },
        },
        yaxis: [
          {
            seriesName: _vm.$t('Report.invoiceCount'),
            opposite: true,
            axisTicks: { show: true },
            axisBorder: { show: true },
            labels: { formatter: _vm.wholeNumber },
            title: { text: _vm.$t('Report.invoiceCount') },
            forceNiceScale: true,
            min: 0,
          },
          {
            seriesName: _vm.$t('Report.totalIncludingTax'),
            axisTicks: { show: true },
            axisBorder: { show: true },
            labels: { formatter: _vm.formatAmount },
            title: { text: _vm.$t('Report.totalSales') },
            lines: {
              show: true,
            },
            forceNiceScale: true,
          },
          {
            seriesName: _vm.$t('Report.totalIncludingTax'),
            show: false,
            labels: { formatter: _vm.formatAmount },
          } ],
        legend: {
          position: 'top',
          onItemClick: {
            toggleDataSeries: false,
          },
        },
        stroke: {
          curve: [ 'straight', 'smooth', 'smooth' ],
          width: [ 1, 2, 3 ],
          dashArray: [ 0, 3, 0 ],
        },
        colors: [ '#3E4957','#3F88C5', '#37AF57' ],
      },"series":[
        {
          name: _vm.$t('Report.invoiceCount'),
          type: 'line',
          data: _vm.generalInvoiceStatistics.map(function (e) { return e.numberOfInvoices; }),
        },
        {
          name: _vm.$t('Report.totalIncludingTax'),
          type: 'line',
          data: _vm.generalInvoiceStatistics.map(function (e) { return e.totalIncludingTax; }),
        },
        {
          name: _vm.$t('Report.totalExcludingTax'),
          type: 'area',
          data: _vm.generalInvoiceStatistics.map(function (e) { return e.totalExcludingTax; }),
        } ]}})],1),_c('s-button',{attrs:{"icon":_vm.showTable ? 'eye-slash' : 'eye'},on:{"click":function($event){_vm.showTable = !_vm.showTable}}},[_vm._v(" "+_vm._s(_vm.$t('Report.table'))+" ")]),(_vm.showTable)?_c('s-table',{staticClass:"table",attrs:{"data":_vm.generalInvoiceStatistics}},[_c('s-column',{attrs:{"header":_vm.$t('Report.month'),"content-getter":"period"}}),_c('s-column',{class:'table-quantity',attrs:{"header":_vm.$t('Report.invoiceCount'),"content-getter":"numberOfInvoices"}}),_c('s-column',{class:'table-amount',attrs:{"header":_vm.$t('Report.totalExcludingTax')},scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("formatAmount")(item.totalExcludingTax))+" ")]}}],null,false,746129861)}),_c('s-column',{class:'table-amount',attrs:{"header":_vm.$t('Report.totalIncludingTax')},scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("formatAmount")(item.totalIncludingTax))+" ")]}}],null,false,1928732063)})],1):_vm._e()],1):_c('s-loader')}
var staticRenderFns = []

export { render, staticRenderFns }